import React from "react";

const ArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60px"
      height="60px"
      version="1.1"
      viewBox="0 0 264.58 264.58"
    >
      <rect
        x="-6.7529e-6"
        y="-6.7529e-6"
        width="264.58"
        height="264.58"
        fill="#fff"
      />
      <circle
        cx="132.29"
        cy="132.29"
        r="62.177"
        fill="none"
        stroke="#ddd"
        strokeLinecap="round"
        strokeWidth="7.9375"
      />
      <g
        transform="matrix(-1 0 0 1 266.89 -280.32)"
        fill="none"
        stroke="#57b9ff"
        strokeLinecap="round"
        strokeWidth="7.9375"
      >
        <path d="m109.21 412.61h58.584" />
        <path
          d="m127.15 439.53-26.92-26.92 26.92-26.92"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export default ArrowIcon;
